import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b03e0a74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_4 = { class: "text-h5 font-weight-bold mb-4" }
const _hoisted_5 = {
  align: "center",
  class: "mt-3"
}
const _hoisted_6 = { class: "flex flex-wrap mt-10" }
const _hoisted_7 = { class: "flex-item" }
const _hoisted_8 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_10 = { class: "flex-item" }
const _hoisted_11 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_12 = { class: "flex-item" }
const _hoisted_13 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-item" }, null, -1))
const _hoisted_15 = { class: "mt-5 mb-2 ml-2" }
const _hoisted_16 = { align: "start" }
const _hoisted_17 = { class: "flex flex-wrap" }
const _hoisted_18 = { class: "flex-item" }
const _hoisted_19 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_21 = { class: "flex-item" }
const _hoisted_22 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_24 = { class: "flex-item" }
const _hoisted_25 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_27 = { class: "font-weight-regular ml-4 mt-2 mb-2" }
const _hoisted_28 = { class: "flex-item" }
const _hoisted_29 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_31 = { class: "flex-item" }
const _hoisted_32 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "* ")
], -1))
const _hoisted_34 = { class: "flex-item" }
const _hoisted_35 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }
const _hoisted_36 = { class: "flex-item mb-10" }
const _hoisted_37 = { class: "d-flex text-subtitle-1 text-medium-emphasis ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_cropper = _resolveComponent("cropper")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, {
      response: _ctx.requestResponse,
      isLoading: _ctx.isLoading
    }, null, 8, ["response", "isLoading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("general-info")), 1),
        _createVNode(_component_v_divider, { class: "mt-4" })
      ]),
      (_ctx.hospital && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_img, _mergeProps(props, {
                      width: 163,
                      style: {"border-radius":"50%"},
                      cover: "",
                      src: 
                _ctx.photoUrl != ''
                  ? _ctx.photoUrl
                  : require('../../../../assets/blank.png')
              ,
                      onClick: _ctx.onButtonClick
                    }), {
                      placeholder: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_progress_circular, {
                            color: "#3fb984",
                            indeterminate: ""
                          })
                        ])
                      ]),
                      _: 2
                    }, 1040, ["src", "onClick"]),
                    _createElementVNode("input", {
                      ref: "uploader",
                      class: "d-none",
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageUpload && _ctx.onImageUpload(...args)))
                    }, null, 544)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("image-upload")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_dialog, {
                  modelValue: _ctx.showCropper,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCropper) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      border: "md",
                      class: "pa-6 text-black mx-auto",
                      width: _ctx.smallWindow ? 320 : 600,
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", _hoisted_4, [
                          _createVNode(_component_cropper, {
                            class: "cropper",
                            src: _ctx.localImageUrl,
                            "stencil-props": {
                  aspectRatio: 10 / 11,
                },
                            onChange: _ctx.change
                          }, null, 8, ["src", "onChange"]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_btn, {
                              color: "error",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCropper = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("go-back")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              class: "ml-2",
                              color: "green",
                              onClick: _ctx.saveImage
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["width"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t("name")) + " ", 1),
                    _hoisted_9
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('name'),
                    "prepend-inner-icon": "mdi-pencil",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("email")), 1),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                    density: "compact",
                    readonly: "",
                    placeholder: _ctx.$t('email'),
                    "prepend-inner-icon": "mdi-email-outline",
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("phoneNumber")), 1),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.phoneNumber,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phoneNumber) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('phoneNumber'),
                    "prepend-inner-icon": "mdi-cellphone",
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("doctor.clinic-info")), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$t("street")) + " ", 1),
                    _hoisted_20
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.street,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.street) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('street'),
                    "prepend-inner-icon": "mdi-map-marker",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("post")) + " ", 1),
                    _hoisted_23
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.postCode,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.postCode) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('post'),
                    "prepend-inner-icon": "mdi-numeric",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createTextVNode(_toDisplayString(_ctx.$t("city")) + " ", 1),
                    _hoisted_26
                  ]),
                  _createVNode(_component_v_autocomplete, {
                    class: "ml-2",
                    modelValue: _ctx.chosenAddress,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.chosenAddress) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('city'),
                    items: _ctx.addressOptions,
                    "item-title": _ctx.getCityAddress,
                    "item-value": _ctx.getCityAddressValue,
                    "prepend-inner-icon": "mdi-city",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    onInput: _ctx.emitCityInput,
                    style: {"min-width":"300px"}
                  }, {
                    item: _withCtx(({ props, item }) => [
                      (!_ctx.cityLoading)
                        ? (_openBlock(), _createBlock(_component_v_list_item, _normalizeProps(_mergeProps({ key: 0 }, props)), {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.raw.name), 1)
                            ]),
                            subtitle: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.raw.country), 1)
                            ]),
                            _: 2
                          }, 1040))
                        : _createCommentVNode("", true)
                    ]),
                    "no-data": _withCtx(() => [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("no-data")), 1)
                    ]),
                    "append-inner": _withCtx(() => [
                      (_ctx.cityLoading)
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            class: "ml-2"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "items", "item-title", "item-value", "rules", "onInput"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createTextVNode(_toDisplayString(_ctx.$t("state")) + " ", 1),
                    _hoisted_30
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.state,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('state'),
                    "prepend-inner-icon": "mdi-map-marker",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createTextVNode(_toDisplayString(_ctx.$t("country")) + " ", 1),
                    _hoisted_33
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.country,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.country) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('country'),
                    "prepend-inner-icon": "mdi-earth",
                    variant: "outlined",
                    rules: _ctx.notEmptyRule,
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("doctor.teaching-uni")), 1),
                  _createVNode(_component_v_autocomplete, {
                    class: "ml-2",
                    modelValue: _ctx.university,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.university) = $event)),
                    items: _ctx.universities,
                    "item-title": _ctx.getUniversityName,
                    "items-icons": _ctx.getUniversityLogo,
                    density: "compact",
                    placeholder: _ctx.$t('university'),
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, {
                    item: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: item.raw.logo,
                            width: "20",
                            class: "mr-5"
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items", "item-title", "items-icons", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("doctor.link")), 1),
                  _createVNode(_component_v_text_field, {
                    class: "ml-2",
                    modelValue: _ctx.link,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.link) = $event)),
                    density: "compact",
                    placeholder: _ctx.$t('doctor.link'),
                    "prepend-inner-icon": "mdi-link",
                    variant: "outlined",
                    style: {"min-width":"300px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_footer, { style: {"display":"flex","width":"96%","justify-content":"end","background-color":"#f2f2f2"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                class: "mr-10",
                rounded: "lg",
                color: "#3fb984",
                variant: "flat",
                size: "large",
                width: "150",
                loading: _ctx.isSaving,
                disabled: !_ctx.infoCompleted,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveProfileData()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}